module.exports = __webpack_public_path__ + "static/media/davidsack.67887737.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/davidsack.webp
// module id = 489
// module chunks = 0